/**
 * In some cases it comes handy to have locally the Images that are being used
 * since its easier (by Icon component in this project) to manage their
 * attributes (path, circle, etc)
 */
enum Images {
	authLayout = '/img/dashboard/authLayout.png',
	logo = '/logos/logo.webp',
	logoSVG = '/logos/logo.svg',
	logoWEBP = '/logos/logo.webp',
	logoLoginSVG = '/logos/logo-login.svg',
	aboutUs = '/img/landing/svg/banner-about.webp',
	superLawyersLogo = '/img/landing/svg/super-lawyers.svg',
	avPreeminentLogo = '/img/landing/svg/av-preeminent-logo.svg',
	circle = '/img/landing/svg/circle.svg',
	hatLogo = '/logos/hat-logo.png',
	hatLogoSVG = '/logos/hat-logo.svg',
	hatLarge = '/img/landing/svg/hat-large.svg',
	ellipseRight = '/img/landing/svg/ellipse-right.svg',
	hatCut = '/img/landing/hat-cut.png',
	bannerMobile = '/img/landing/svg/banner-mobile.svg',
	antitrust = '/img/landing/categories/antitrust.svg',
	commodities = '/img/landing/categories/commodities.svg',
	consumer = '/img/landing/categories/consumer.svg',
	data = '/img/landing/categories/data.svg',
	health = '/img/landing/categories/health.svg',
	securities = '/img/landing/categories/securities.svg',
	superLawyer = '/img/landing/awards/super-lawyers.svg',
	preeminent = '/img/landing/awards/preeminent.svg',
	uploadCloud = '/img/common/upload-cloud.png',
	whatHappensGroup = '/img/dashboard/what-happens-group.png',
	whereToFindThings = '/img/dashboard/where-to-find-things.png',
	youAllSet = '/img/dashboard/you-all-set.png',
}

export default Images;
